import React from "react";
import {connect} from "react-redux";
import { ResponsiveImage } from "@quintype/components";
import get from 'lodash/get';

function ImageFallbackIcon({width= 80, height= 60, iconColor = '#99B0CB'}) {
    const randomNumber = new Date().getMilliseconds();
    return <svg width={width} height={height} viewBox="0 0 102 76" version="1.1">
        <g id={`demo-home-copy-${randomNumber}`} stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-377.000000, -314.000000)">
            <g id={`Group-13-${randomNumber}`} transform="translate(377.000000, 314.000000)">
                <path d="M43.2,49.7 L62.2,19.2 L87.2,59.4 L17,59.4 L32.8,39.4 L43.2,49.7 Z M29.9,28.6 C25.8683213,28.6 22.6,25.3316787 22.6,21.3 C22.6,17.2683213 25.8683213,14 29.9,14 C33.9316787,14 37.2,17.2683213 37.2,21.3 C37.2,25.3316787 33.9316787,28.6 29.9,28.6 Z" id={`Combined-Shape-${randomNumber}`} fill={iconColor} fillRule="nonzero"></path>
                <rect id={`Rectangle-19-${randomNumber}`} stroke={iconColor} strokeWidth="3" x="1.5" y="1.5" width="99" height="73" rx="3"></rect>
            </g>
        </g>
    </svg>
}


function ImageFallbackBase(props) {
    const {bgColor= '#d8e7f6', iconColor, className, config = {} } = props;
    const imageFallbackUrl = get(config, ['theme-attributes', 'imageFallbackUrl'], null);
    if(imageFallbackUrl){
        return <div className="image-fallback">
            <figure className={`${className} set-fallback`}>
                <ResponsiveImage slug={imageFallbackUrl}
                                 metadata={{}}
                                 aspect-ratio={[16,9]}
                                 defaultWidth= {480}
                                 widths={[250,480,640]}
                                 imgParams={{auto: ['format','compress']}}
                                 className=''
                                 alt={'image-fallback'} />
            </figure>
        </div>;
    }

    return <div className="image-fallback" style={{backgroundColor: bgColor}}>
        <figure className={className}>
            <ImageFallbackIcon iconColor={iconColor}/>
        </figure>
    </div>
}

function mapStateToProps(state) {
    return {
        config: state.qt.config || {},
    }
}

export const ImageFallback = connect(mapStateToProps, () => ({}))(ImageFallbackBase);